import { Component, OnInit, OnDestroy, ViewChild, Inject, ComponentFactoryResolver } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';
import { ServerService } from '../../../../service/server/server.service';
import { MatTableDataSource } from '@angular/material/table';
import { OrderDetaileComponent } from '../../wharehouse-order/order-detaile/order-detaile.component';
import Num2persian from 'num2persian';
import { ChequeDetaileComponent } from '../../../finance/cheque/cheque-detaile/cheque-detaile.component';
import { Financial2DetaileComponent } from '../../../finance/financial2/financial2-detaile/financial2-detaile.component';
import { ChequeSelectComponent } from '../../../finance/cheque/cheque-select/cheque-select.component';
import { UserDetaile2Component } from '../../../../system/user/user-detaile2/user-detaile2.component';
import { NewFastMaterialComponent } from '../../new-fast-material/new-fast-material.component';
import { NewFastMaterial2Component } from '../../new-fast-material2/new-fast-material2.component';

@Component({
  selector: 'app-invoice-detaile',
  templateUrl: './invoice-detaile.component.html',
  styleUrls: ['./invoice-detaile.component.scss']
})
export class InvoiceDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  list_order: any = [];
  search_array: any = [];
  invoice_type_id: number | any;
  new_invoice_id: number | undefined;
  material: number | undefined;
  sum_all: number = 0;
  sum_all_real: number = 0;
  currency_title: string | undefined;
  sum_all_letter: string | undefined;
  remain_letter: string | undefined;
  token: any = Math.floor(Math.random() * 99999999999999);
  remain: number = 0;
  x: number = 0;
  x2: number = 0;
  x3: number = 0;

  date3_main: string;

  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  dataSource: any | any;
  displayedColumns = ['row', 'cate', 'material', 'place', 'title', 'number', 'weight', 'price', 'sum', 'operation'];

  public dataSource2: any | undefined;
  displayedColumns2 = ['row', 'payment_type', 'amount', 'type', 'bank', 'account', 'cheque', 'due', 'status', 'operation'];
  list_record_financial2: any = [];
  list_cheque: any = [];
  amount: number | undefined;
  document_type: number | undefined;
  list_not: any = [];
  result: any;
  readonly: boolean = false;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<InvoiceDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));

    this.serverService.get_financial2().subscribe(
      (res) => {
        this.list_record_financial2.unshift(res);
        this.dataSource2.data = this.list_record_financial2;
        this.get_amount(2);
        this.get_sum_all();
        if (this.form1_group.value.user) this.get_account(this.form1_group.value.user);
      }
    )

    this.serverService.get_invoice_material().subscribe(
      (res) => {
        this.list_order.unshift(res);
        this.dataSource.data = this.list_order;
        this.get_sum_all();
        if (this.form1_group.value.user) this.get_account(this.form1_group.value.user);
      }
    );

    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.readonly = dialog_data.readonly;
      this.invoice_type_id = dialog_data.invoice_type_id;
      this.type_task = dialog_data.type_task;
      this.new_invoice_id = dialog_data.new_invoice_id;
      this.create_form1();
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.form1_group.patchValue({
          'invoice_number': this.new_invoice_id
        });
        this.get_status();
        if (this.invoice_type_id > 0) {
          this.get_invoice_type();
        }
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          invoice_number: dialog_data.search_array.invoice_number,
          invoice_date: dialog_data.search_array.invoice_date,
          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,
          user: dialog_data.search_array.user,
          user_title: dialog_data.search_array.user_title,
          currency: dialog_data.search_array.currency,
          currency_title: dialog_data.search_array.currency_title,
          rate: dialog_data.search_array.rate,
          invoice_type_title: dialog_data.search_array.invoice_type_title,
          invoice_type: dialog_data.search_array.invoice_type,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_order();
    this.get_financial2();
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'invoice_number': new FormControl(null),
      'invoice_date': new FormControl(null),
      'invoice_type_title': new FormControl(null),
      'invoice_type': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'user_title': new FormControl(null),
      'user': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'currency_title': new FormControl(null),
      'currency': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'rate': new FormControl(1, [Validators.pattern('[0-9]{1,}')]),
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['status_id'].setValidators([Validators.required])
      this.form1_group.controls['rate'].setValidators([Validators.required])
    }
  }






  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_account(user: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1731, user: user, token: this.token }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.remain = 0;
          this.remain = res['result'][0].balance;
          this.x = 0;
          for (var j = 0; j < this.list_order.length; j++) {
            if (this.list_order[j].wharehouse_order_trash == 3) {
              this.x = this.x + Number(this.list_order[j].wharehouse_order_cost * this.list_order[j].wharehouse_order_number);
            }
          }
          this.x3 = 0;
          for (var j = 0; j < this.list_record_financial2.length; j++) {
            if (this.list_record_financial2[j].finance_financial2_trash == 3) {
              this.x3 = this.x3 + Number(this.list_record_financial2[j].amount);
            }
          }
          if (this.document_type == 1) this.remain = Number(this.remain) + Number(this.x) - Number(this.x3);
          if (this.document_type == 2) this.remain = Number(this.remain) - Number(this.x) + Number(this.x3);
          this.remain_letter = Num2persian(this.remain);

          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در $";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      invoice_number: this.form1_group.value.invoice_number,
      invoice_date: this.form1_group.value.invoice_date,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      user: this.form1_group.value.user,
      user_title: this.form1_group.value.user_title,
      currency: this.form1_group.value.currency,
      currency_title: this.form1_group.value.currency_title,
      invoice_type_title: this.form1_group.value.invoice_type_title,
      invoice_type: this.form1_group.value.invoice_type,
      rate: this.form1_group.value.rate,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6019, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].wharehouse_invoice_title,
            'invoice_number': res['result'][0].wharehouse_invoice_number,
            'invoice_date': res['result'][0].wharehouse_invoice_date3,
            'sort': res['result'][0].wharehouse_invoice_sort,
            'status_id': res['result'][0].wharehouse_invoice_status,
            'status_title': res['result'][0].status_title,
            'user': res['result'][0].wharehouse_invoice_user,
            'user_title': res['result'][0].user_title,
            'currency': res['result'][0].wharehouse_invoice_currency,
            'currency_title': res['result'][0].site_currency_title,
            'rate': res['result'][0].wharehouse_invoice_rate,
            'invoice_type_title': res['result'][0].wharehouse_invoice_type_title,
            'invoice_type': res['result'][0].wharehouse_invoice_type,
          }
          );
          this.date3_main = res['result'][0].wharehouse_invoice_date3_main;
          this.document_type = res['result'][0].document_type;
          this.currency_title = res['result'][0].site_currency_title;
          this.title = res['result'][0].wharehouse_invoice_type_title;
          this.get_account(res['result'][0].wharehouse_invoice_user);
          if (!res['result'][0].wharehouse_invoice_number) {
            this.form1_group.patchValue({
              'invoice_number': this.new_invoice_id
            });
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6020, "user_id": this.user_id
      , 'status_id': this.form1_group.value.status_id
      , 'invoice_number': this.form1_group.value.invoice_number
      , 'invoice_date': this.date3_main
      , 'user': this.form1_group.value.user
      , 'currency': this.form1_group.value.currency
      , 'rate': this.form1_group.value.rate
      , 'sort': this.form1_group.value.sort
      , 'invoice_type': this.form1_group.value.invoice_type
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  change_start_date() {
    this.date3_main = this.form1_group.value.invoice_date;
  }

  update(): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      'address': 6022, "user_id": this.user_id
      , 'invoice_number': this.form1_group.value.invoice_number
      , 'invoice_date': this.date3_main
      , 'user': this.form1_group.value.user
      , 'currency': this.form1_group.value.currency
      , 'rate': this.form1_group.value.rate
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'invoice_type': this.form1_group.value.invoice_type
      , 'token': this.token
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.update_order(res['result'][0]);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update 


  update_order(result: any) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6023, id: this.id, token: this.token }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = { result: res['result'][0] }
          this.matDialogRef.close(this.result);
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  add_user(): any {
    if (this.readonly == true) {
      return false;
    }
    var dialogRef = this.dialog.open(UserDetaile2Component, {
      width: '45rem',
      height: 'auto'
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        this.form1_group.patchValue({
          'user_title': res['result'][0].user_title,
          'user': res['result'][0].user_id,
        });
      }
    )
  }

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  user_counter(id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6099, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  load_services(id: number): any {
    if (this.readonly == true) {
      return false;
    }
    var where = "";
    var code_id;
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, where: where, code_id: code_id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 24) {
            this.form1_group.patchValue({
              'user': res.id,
              'user_title': res.title
            })
            this.user_counter(res.id);
            this.get_account(res.id);
          }
          if (id == 216) {
            this.form1_group.patchValue({
              'currency': res.id,
              'currency_title': res.title
            });
            this.currency_title = res.title;
          }
          if (id == 196) {
            this.form1_group.patchValue({
              'invoice_type': res.id,
              'invoice_type_title': res.title
            })
          }
        }
      }
    )

  }



  reset_input(id: number) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 161) {
      this.form1_group.patchValue({
        'user_title': null,
        'user': null
      })
    }
    if (id == 216) {
      this.form1_group.patchValue({
        'currency': null,
        'currency_title': null
      });
      this.currency_title = '';
    }
    if (id == 196) {
      this.form1_group.patchValue({
        'invoice_type': null,
        'invoice_type_title': null
      })
    }
    if (id == 24) {
      this.form1_group.patchValue({
        'user': null,
        'user_title': null
      })
    }
  }

  get_invoice_type() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6026, id: this.invoice_type_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              invoice_type: res['result'][0].wharehouse_invoice_type_id,
              invoice_type_title: res['result'][0].wharehouse_invoice_type_title
            });
            this.title = res['result'][0].wharehouse_invoice_type_title;
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //**************************************************** */
  get_order() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6027, invoice: this.id }).subscribe(
      (res: any) => {
        this.list_order = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_order.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_order);
          this.get_sum_all();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  add_to_invoice(): any {
    if (this.readonly == true) {
      return false;
    }
    const dialogRef = this.dialog.open(NewFastMaterial2Component, {
      'width': '70rem',
      'height': 'auto',
      'data': { token: this.token, invoice_id: this.id, code: this.code, ref: 'invoice' }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.list_order.unshift(res.result);
          this.dataSource.data = this.list_order;
          this.get_sum_all();
        }
      }
    )
  }

  open_order(i, type_task, id): any {
    if (this.readonly == true) {
      return false;
    }
    const dialogRef = this.dialog.open(OrderDetaileComponent, {
      width: '25rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: type_task, id: id, trash: 3, code: this.code, title: this.title, invoice_id: this.id, ref: 'invoice', token: this.token }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (type_task == 1) {
          }
          else if (type_task == 2) {
            this.list_order[i].wharehouse_material_title = res.result.wharehouse_material_title;
            this.list_order[i].wharehouse_material_cate_title = res.result.wharehouse_material_cate_title;
            this.list_order[i].wharehouse_order_title = res.result.wharehouse_order_title;
            this.list_order[i].wharehouse_order_number = res.result.wharehouse_order_number;
            this.list_order[i].wharehouse_order_status_title = res.result.wharehouse_order_status_title;
            this.list_order[i].wharehouse_order_status_color = res.result.wharehouse_order_status_color;
            this.list_order[i].wharehouse_invoice_title = res.result.wharehouse_invoice_title;
            this.list_order[i].wharehouse_order_sort = res.result.wharehouse_order_sort;
            this.list_order[i].wharehouse_order_cost = res.result.wharehouse_order_cost;
            this.list_order[i].status_title = res.result.status_title;
            this.list_order[i].site_currency_title = res.result.site_currency_title;
            this.list_order[i].sum = res.result.sum;
            this.get_sum_all();
            if (res.result.wharehouse_order_trash == 3 && this.form1_group.value.user) this.get_account(this.form1_group.value.user);
          }
        }
      }
    )
  }

  get_sum_all() {
    this.x2 = 0;
    for (var j = 0; j < this.list_order.length; j++) {
      if (this.list_order[j].wharehouse_order_trash == 3) {
        this.x2 = Number(this.x2) + Number(this.list_order[j].wharehouse_order_cost * this.list_order[j].wharehouse_order_number);
      }
    }
    this.sum_all = 0;
    for (var i = 0; i < this.list_order.length; i++) {
      this.sum_all += this.list_order[i].sum;
    }
    this.sum_all_letter = Num2persian(this.sum_all);
    if (this.document_type == 1) this.sum_all_real = Number(this.sum_all) + Number(this.x2);
    if (this.document_type == 2) this.sum_all_real = Number(this.sum_all) - Number(this.x2);
  }

  check_delete_order(id: number, material: number, status_add: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (this.list_order.length == 1 && this.list_record_financial2.length > 1) {
      var pe_message = "شما حداقل یک تراکنش دارید .باید حتما یک قطعه دز لیست قطعات وجود داشته باشید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return false;
    }
    if (status_add == 1) {
      this.check_to_delete(id, material);
    } else {
      this.delete_order(id);
    }
  }

  check_to_delete(id: number, material: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6003, material: material, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].inventory >= 0) {
            this.delete_order(id);
          }
          else {
            var pe_message = "تعداد خروجی های یک کالا نمی تواند بیشتر از ثبت ورودی ها باشد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  delete_order(id: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var address;
      var obj = {
        'address': 6028, "user_id": this.user_id
        , 'id': id
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_order.splice(this.list_order.findIndex((index: any) => index.wharehouse_order_id == id), 1);
            this.dataSource.data = this.list_order;
            this.get_sum_all();
            var pe_message = "با موفقیت حذف شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve	', pe_message, 1, 'close', pe_action);
          }//end if
          else {
            var pe_message = "خطا در حذف";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve	', pe_message, 1, 'close', pe_action);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //******************************************************************************************************** */
  check_access2(i: number, type_task: number, page: number, id: any, excel: number, loading: number, cheque: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 3) {
              this.delete_financial2(i, id, cheque);
            }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_financial2() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6029
      , user_id: this.user_id
      , id: this.id
      , ref: 2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            res['result'][i].color = 'transparent';
            this.list_record_financial2.push(res['result'][i]);
          }//end for
          this.dataSource2 = new MatTableDataSource(this.list_record_financial2);
          this.get_amount(1);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data

  get_amount(ref: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6030, id: this.id, token: this.token, ref: 2 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.amount = res['result'][0].amount;
          if (ref == 1) {
            this.list_record_financial2.push({ 'amount': this.amount, 'footer': true });
          } else {
            this.list_record_financial2[this.list_record_financial2.length - 1].amount = this.amount;
          }
          this.dataSource2.data = this.list_record_financial2;
        }//end if
        else {
          var pe_message = "خطا در محاسبه عدد نهایی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  delete_financial2(i: number, id: number, cheque: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var address;
      var obj = {
        'address': 6031, "user_id": this.user_id
        , 'id': id
        , cheque: cheque
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            if (this.list_record_financial2[i].site_cheque_type == 2 || (
              this.list_record_financial2[i].site_cheque_type == 1 && this.document_type == 1)) {
              this.update_cheque2(id, cheque);
            } else if (this.list_record_financial2[i].site_cheque_type == 1 && this.document_type == 2) {
              this.update_cheque3(id, cheque);
            } else {
              this.list_record_financial2.splice(this.list_record_financial2.findIndex((index: any) => index.finance_financial2_id == id), 1);
              this.dataSource2.data = this.list_record_financial2;
              this.recieve_message(false, "", "", 1, "", "");
            }
            this.get_amount(2);
            if (this.form1_group.value.user) this.get_account(this.form1_group.value.user);
          }//end if
          else {
            this.message(true, this.serverService.message_delete_alarm(), 1, this.serverService.message_action());
          }
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete

  update_cheque2(id: number, cheque: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', {
      address: 6032, cheque: cheque, document_type: this.document_type
    }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record_financial2.splice(this.list_record_financial2.findIndex((index: any) => index.finance_financial2_id == id), 1);
          this.dataSource2.data = this.list_record_financial2;
          var pe_message = "با موفقیت حذف شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update_cheque3(id: number, cheque: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', {
      address: 6033, cheque: cheque
    }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record_financial2.splice(this.list_record_financial2.findIndex((index: any) => index.finance_financial2_id == id), 1);
          this.dataSource2.data = this.list_record_financial2;
          var pe_message = "با موفقیت حذف شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  open_detaile_financial2(index: number, type_task: number, id: number, cheque_id: number, cheque_type: number, footer: boolean): any {
    if (this.readonly == true || footer == true) {
      return false;
    }
    if (cheque_type == 1 || cheque_type == 2) {
      this.select_introducing_cheque(index, 2, cheque_id);
      return false;
    }
    var x = 0;
    if (this.document_type == 1) {
      for (var i = 0; i < this.list_record_financial2.length; i++) {
        if (this.list_record_financial2[i].site_cheque_type == 2) {
          var pe_message = "در فاکتورهای فروش نمی توانید تراکنش ار نوع پرداختی داشته باشید";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          return false;
        }
      }
    }

    if (!this.form1_group.value.user) {
      var pe_message = "برای ثبت و یا ویرایش تراکنش در ابتدا باید نام تامبن کننده مشخص شود";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }

    if (this.list_order.length == 0) {
      var pe_message = "برای ثبت معرفی چک می بایست حداقل یک قطعه ثبت کرده باشید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }

    const dialogRef = this.dialog.open(Financial2DetaileComponent, {
      width: '45rem',
      height: 'auto',
      disableClose: true,
      data: {
        type_task: type_task, id: id, search_array: this.search_array
        , code: this.code, title: this.title, financial: this.id
        , user: this.form1_group.value.user
        , document: this.form1_group.value.cheque_type
        , sum: Number(this.sum_all) - Number(this.amount)
        , token: this.token, ref: 2
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (type_task == 1) {
            /*
            this.list_record_financial2.unshift(res.result[0]);
            this.dataSource2.data = this.list_record_financial2;
            this.get_amount(2);
            this.get_sum_all();
            if (this.form1_group.value.user) this.get_account(this.form1_group.value.user);
            */
          }
          else if (type_task == 2) {
            if (res.change == true) {
              this.list_record_financial2[index].user_title = res.result.user_title;
              this.list_record_financial2[index].amount = res.result.amount;
              this.list_record_financial2[index].finance_payment_type_title = res.result.finance_payment_type_title;
              this.list_record_financial2[index].site_cheque_type_title = res.result.site_cheque_type_title;
              this.list_record_financial2[index].finance_financial2_sort = res.result.finance_financial2_sort;
              this.list_record_financial2[index].site_cheque_status_title = res.result.site_cheque_status_title;
              this.list_record_financial2[index].cheque_account = res.result.cheque_account;
              this.list_record_financial2[index].cheque_number = res.result.cheque_number;
              this.list_record_financial2[index].site_bank_title = res.result.site_bank_title;
              this.list_record_financial2[index].due_date = res.result.due_date;
              this.get_amount(2);
              this.get_sum_all();
              if (this.form1_group.value.user) this.get_account(this.form1_group.value.user);
            }
          }
        }
      }
    )
  }

  select_introducing_cheque(i: number, type_task: number, id: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (!this.form1_group.value.user) {
      var pe_message = "برای ثبت و یا ویرایش تراکنش در ابتدا باید نام طرف حساب مشخص شود";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    if (this.list_order.length == 0) {
      var pe_message = "برای ثبت معرفی چک می بایست حداقل یک قطعه ثبت کرده باشید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    this.list_not = [];
    for (var i = 0; i < this.list_record_financial2.length; i++) {
      if (this.list_record_financial2[i].site_cheque_type == 2) {
        this.list_not.push(this.list_record_financial2[i].cheque_numbers_id);
      }
    }
    var x;
    if (this.form1_group.value.invoice_type == 3) {
      x = 1;
    }
    else if (this.form1_group.value.invoice_type == 1) {
      x = 2
    }
    const dialogRef = this.dialog.open(ChequeDetaileComponent, {
      width: '45rem',
      height: 'auto',
      data: {
        type_task: type_task, code: this.code, type: x, id: id, ref: 'financial', token: this.token
        , user: this.form1_group.value.user, list_not: this.list_not
      }

    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (type_task == 1) {
            this.insert_cheque(false, res.result.site_cheque_type, res.result.site_cheque_id);
          } else {
            this.list_record_financial2[i].amount = res.result.site_cheque_price;
            this.list_record_financial2[i].site_bank_title = res.result.site_bank_title;
            this.list_record_financial2[i].cheque_account = res.result.accounts_number;
            this.list_record_financial2[i].cheque_number = res.result.site_cheque_number;
            this.list_record_financial2[i].due_date = res.result.due_date;
            this.list_record_financial2[i].site_cheque_status_title = res.result.site_cheque_status_title;
            this.get_amount(2);
          }
        }
      }
    )
  }

  select_cheque(type): any {
    if (this.readonly == true) {
      return false;
    }
    if (!this.form1_group.value.user) {
      var pe_message = "برای ثبت و یا ویرایش تراکنش در ابتدا باید نام تامین کننده مشخص شود";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    if (this.list_order.length == 0) {
      var pe_message = "برای ثبت معرفی چک می بایست حداقل یک قطعه ثبت کرده باشید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    const dialogRef = this.dialog.open(ChequeSelectComponent, {
      width: '64rem',
      height: 'auto',
      data: { user: this.form1_group.value.user, document_type: this.document_type, token: this.token, type: type }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.insert_cheque(true, res.result.site_cheque_type, res.result.site_cheque_id);
        }
      }
    )
  }

  insert_cheque(loading: boolean, cheque_type: number, cheque: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == true) this.loading = true;
    var obj = {
      'address': 6034, "user_id": this.user_id
      , 'cheque': cheque
      , 'payment_type': 2
      , 'cheque_type': cheque_type
      , 'document_type': this.document_type
      , 'financial': this.id
      , 'token': this.token
      , 'trash': 3
      , 'ref': 2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          res.result[0].color = 'transparent';
          this.list_record_financial2.unshift(res.result[0]);
          this.dataSource2.data = this.list_record_financial2;
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "شماره چک انتخابی قبلا در سیستم دریافت و پرداخت استفاده شده است";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update_cheque(): any {
    if (this.readonly == true) {
      return false;
    }
    var obj = {
      address: 6035, token: this.token, id: this.id, ref: 2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(this.result);
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //******************************************************************************************************** */
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

